import React, { useEffect, useState } from 'react'


import { DualSlider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  func, number, bool, array, string,
} from 'prop-types'

import WithTriangleUiContext from 'Pods/Shared/Hocs/WithTriangleUiContext'
import i18n from 'Pods/Shared/I18n'

import { EMPTY_ARRAY, NOOP } from 'Utils/stableDefaults'

function PolyCountSlider({
  maxPolygonThreshold,
  minPolygonThreshold,
  setSelectedFilters,
  withTitleDivider = false,
  rangeFilters = EMPTY_ARRAY,
  selectedPolygonRangeFilters = EMPTY_ARRAY,
  setShouldResetPolygonRange,
  shouldResetPolygonRange,
  handleEnterKeyPress = NOOP,
  trackFilterChange,
  locale = 'en',
}) {
  const [previousFrom, setPreviousFrom] = useState()
  const [previousTo, setPreviousTo] = useState()

  const sliderTitle = i18n.t('listingPage.filters.polyCountRange', { ns: 'rails', lng: locale })

  useEffect(() => {
    if (!selectedPolygonRangeFilters.length || previousFrom || previousTo) {
      return
    }

    const customPolygonRange = selectedPolygonRangeFilters.find(value => !rangeFilters.includes(value))
    if (customPolygonRange) {
      const [from, to] = customPolygonRange.split('_').slice(1)
      setPreviousFrom(Number(from))
      setPreviousTo(Number(to))
    }
  }, [selectedPolygonRangeFilters])

  useEffect(() => {
    if (shouldResetPolygonRange) {
      setPreviousFrom(minPolygonThreshold)
      setPreviousTo(maxPolygonThreshold)
      setShouldResetPolygonRange(false)
    }
  }, [shouldResetPolygonRange])

  function handlePolygonChange({ min, max }) {
    const isDefaultValue = min === minPolygonThreshold && max === maxPolygonThreshold
    const previousValue = `range_${previousFrom}_${previousTo}`
    const newFilter = selectedPolygonRangeFilters.filter(value => value !== previousValue)

    if (isDefaultValue) {
      setSelectedFilters({ name: 'polygonRange', value: newFilter })
      setPreviousFrom(min)
      setPreviousTo(max)
      window.removeCurrentSearchFilter({ name: 'polygonRange' })
      return
    }

    const newMinPolygon = Math.max(min, minPolygonThreshold)
    const newMaxPolygon = Math.min(max, maxPolygonThreshold)
    const newValue = `range_${newMinPolygon}_${newMaxPolygon}`

    setSelectedFilters({ name: 'polygonRange', value: [...newFilter, newValue] })
    trackFilterChange({ name: 'polygonRange', value: newValue })
    setPreviousFrom(min)
    setPreviousTo(max)
  }

  return (
    <div className="metaverse-listing__poly-count-slider">
      <DualSlider
        id="poly-count-slider"
        minThreshold={minPolygonThreshold}
        maxThreshold={maxPolygonThreshold}
        max={Math.min(
          Number(previousTo || maxPolygonThreshold),
          maxPolygonThreshold
        )}
        min={Math.max(
          Number(previousFrom || minPolygonThreshold),
          minPolygonThreshold
        )}
        name="poly-count-slider"
        onChange={handlePolygonChange}
        title={sliderTitle}
        withSliderOnTop
        withMarkers
        isShortenedValue
        withTextAlignCenter
        withTitleDivider={withTitleDivider}
        onEnterKeyPress={handleEnterKeyPress}
      />
    </div>
  )
}

PolyCountSlider.propTypes = {
  setSelectedFilters: func.isRequired,
  maxPolygonThreshold: number.isRequired,
  minPolygonThreshold: number.isRequired,
  withTitleDivider: bool,
  rangeFilters: array,
  selectedPolygonRangeFilters: array,
  setShouldResetPolygonRange: func.isRequired,
  shouldResetPolygonRange: bool.isRequired,
  handleEnterKeyPress: func,
  trackFilterChange: func.isRequired,
  locale: string,
}

const mapStateToProps = ({
  maxPolygonThreshold,
  minPolygonThreshold,
  selectedFilters,
  setMultipleFilters,
  setSelectedFilters,
  filtersOptions,
  setShouldResetPolygonRange,
  shouldResetPolygonRange,
  trackFilterChange,
  locale,
}) => {
  const rangeFilters = filtersOptions.polygons.filters.map(({ value }) => value)
  const selectedPolygonRangeFilters = selectedFilters.polygonRange

  return {
    maxPolygonThreshold,
    minPolygonThreshold,
    setMultipleFilters,
    setSelectedFilters,
    rangeFilters,
    selectedPolygonRangeFilters,
    setShouldResetPolygonRange,
    shouldResetPolygonRange,
    trackFilterChange,
    locale,
  }
}

export default WithTriangleUiContext(mapStateToProps)(PolyCountSlider)
